import { render, staticRenderFns } from "./complianceDocuments.vue?vue&type=template&id=7c84e03d&scoped=true"
import script from "./complianceDocuments.vue?vue&type=script&lang=js"
export * from "./complianceDocuments.vue?vue&type=script&lang=js"
import style0 from "./complianceDocuments.vue?vue&type=style&index=0&id=7c84e03d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c84e03d",
  null
  
)

export default component.exports